import {ResourceBase, ResourceType} from "@integration-frontends/integration/core/model";

export interface GenericFile extends ResourceBase {
  type: ResourceType.GENERIC_FILE;
}
